export const formatDateToMMDD = (dateString: string): string => {
  const date = new Date(dateString);

  // 월(Month)은 0부터 시작하므로 +1 필요
  const month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
  const day = date.getUTCDate().toString().padStart(2, '0');

  return `${month}.${day}`;
};
